module.exports = __webpack_public_path__ + "img/logo.dc3d6686.svg";